export function isParentRelativeValue(value: string) {
  return value.endsWith('%')
}
